import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import 'dayjs/locale/es';
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);
const tz = "Atlantic/Reykjavik";

export const changeDate = (date = "") => {
	let day = "";
	let dayFormat = "";
	day = dayjs(date);
	dayFormat = day.format("YYYY-MM-DD");
	return { day, dayFormat };
};
export const changeDateTimeZone = (date = "") => {
	let day = "";
	let dayFormat = "";
	let dayFormatYear = "";
    let dayLocal = "";
	if (date !== "") {
		day = dayjs(date).tz(tz);
        dayLocal = dayjs(date).tz(tz).locale("es");
		dayFormat = day.format("YYYY-MM-DD");
		dayFormatYear = day.format("YYYY");
	} else {
		day = dayjs();
	}

    return { day, dayFormat, dayFormatYear, dayLocal };
};

export const toDay = () => {
	let day = "";
	let dayFormat = "";
	let dayFormatYear = "";
	day = dayjs();
	dayFormat = day.format("YYYY-MM-DD");
	dayFormatYear = day.format("YYYY");
	return { day, dayFormat, dayFormatYear };
};

export const isDayToDay = (dateInit = "", dateSelect = "") => {
	let isAfter = false;
	if (dateInit !== "" && dateSelect !== "") {
		isAfter = dayjs(dateInit).isSame(dateSelect);
	}
	return isAfter;
};

export const isAfterToDay = (dateInit = "", dateSelect = "") => {
	let isAfter = false;
	if (dateInit !== "" && dateSelect !== "") {
		isAfter = dayjs(dateInit).isAfter(dateSelect);
	}
	return isAfter;
};

export const isBetweenPause = (today = "", dateInit = "", dateClose = "") => {
	let isPause = false;
	const isBetweenPause = dayjs(today).isBetween(dateInit, dateClose, "day", "[]");
	if (isBetweenPause) {
		isPause = true;
	}
	return isPause;
};
